import type { UnroutedReason } from "./types";

// One phrase per reason, read by the plan's hover title AND by the list line —
// the drawing and the panel must admit the same thing in the same words.
export const UNROUTED_REASON_KEYS: Record<UnroutedReason, string> = {
  no_circuit_id_reaches_it: "smartSurveyor.cablesBeta.unroutedReasonNoSchedule",
  not_in_the_estimate: "smartSurveyor.cablesBeta.unroutedReasonNotInEstimate",
  every_circuit_vetoed: "smartSurveyor.cablesBeta.unroutedReasonVetoed",
  every_feasible_circuit_full: "smartSurveyor.cablesBeta.unroutedReasonFull",
  no_feeder: "smartSurveyor.cablesBeta.unroutedReasonNoFeeder",
  unknown: "smartSurveyor.cablesBeta.unroutedReasonUnknown",
};
